import { Form } from "react-bootstrap";

export const FormTypeField = ({ formControlType, register, min, step }) => {
  switch (formControlType) {
    case "date":
      return <Form.Control type="date" {...register} />;
    case "checkbox":
      return <Form.Check type="checkbox" {...register} />;
    case "number":
      return <Form.Control type="number" {...register} min={min} step={step} />;
    case "textarea":
      return <Form.Control as="textarea" rows={3} {...register} />;
    default:
      return <Form.Control type="text" {...register} />;
  }
};

export default FormTypeField;
